import React from 'react';
import { useTranslation } from 'react-i18next';
import FooterContainer from './FooterContainer';
var ProducerFooter = function () {
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    return (React.createElement(FooterContainer, null,
        React.createElement("div", { className: "links" },
            React.createElement("a", { href: "/term.html?role=producer&locale=".concat(i18n.language === 'ja' ? 'ja' : 'en'), target: "_blank", rel: "noopener noreferrer" }, t('links.tos')),
            ' | ',
            React.createElement("a", { href: "/cookie-policy" }, t('links.cookiePolicy')))));
};
export default ProducerFooter;
